import { SupplierFullDtoIn } from '@/models/in/SupplierFullDtoIn';

/**
 * SPR-10302: adding a supplier to a project either picks one the fund already works with or types a
 * new one. Every link needs the office's approval anyway, so picking is about not typing the same
 * supplier twice - and about not misspelling a tax id the office already knows.
 */

/** Digits only: "51-234567-8" and "512345678" are the same tax id. */
export const normalizeTaxId = (taxId: string | null | undefined): string => (taxId ?? '').replace(/\D/g, '');

/** The fund's supplier with exactly this tax id, if any. */
export const findSupplierByTaxId = (
  suppliers: SupplierFullDtoIn[] | undefined,
  taxId: string | null | undefined
): SupplierFullDtoIn | undefined => {
  const wanted = normalizeTaxId(taxId);
  if (!wanted) return undefined;
  return (suppliers ?? []).find((supplier) => normalizeTaxId(supplier.taxId) === wanted);
};

/** The text an option of the picker shows, and what the input holds once one is chosen. */
export const supplierOptionLabel = (supplier: SupplierFullDtoIn): string =>
  `${supplier.name} · ${supplier.taxId}`;
